import ArticleCard from '@/components/base/ArticleCard';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles().slice(0, 6);

  return (
    <section className="py-12 md:py-16">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门爆料精选
          </h2>
          <p className="text-sm text-foreground-600 mt-2">最受关注的吃瓜内容，不容错过</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.slice(0, 3).map((article) => (
            <ArticleCard key={article.id} article={article} variant="featured" />
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-6">
          {featured.slice(3, 6).map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}